"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buttons = void 0;
var _mui = require("@ori-ui/mui");
const Buttons = exports.Buttons = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  marginTop: theme.spacing(3),
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(4)
  }
}));
//# sourceMappingURL=styles.js.map